import { theme } from "@/styles/variables/media"
import { ThemeProvider } from "@emotion/react"
import { PropsWithChildren } from "react"
import { CacheProvider } from "@emotion/react"
import createCache from "@emotion/cache"

const cache = createCache({ key: "css", nonce: "gote-nonce" })

function ThemeLayout(props: PropsWithChildren) {
    return (
        <CacheProvider value={cache}>
            <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
        </CacheProvider>
    )
}

export default ThemeLayout
